export const confApp = {
  API_URL: "https://api.s-digitales.com/api/",
  // API_URL: "https://api-pruebas.consultorio-digital.com/api/",
  // API_URL: "https://localhost:7008/api/",

  // LINK_DOC: "https://consultorio-digital.com/Docs/Negocios",
  // LINK_DOC: "https://dev.s-digitales.com/Docs/Negocios",

  // API_URL: "https://api.s-digitales.com/api/",
  LINK_DOC: "https://consultorio-digital.com/Docs/Negocios",
  VERSION: "2.10.26",
  NIVEL_ESTUDIO: [
    { label: "Preescolar", value: "Preescolar" },
    { label: "Primaria", value: "Primaria" },
    { label: "Secundaria", value: "Secundaria" },
    { label: "Bachillerato", value: "Bachillerato" },
    { label: "Licenciatura", value: "Licenciatura" },
    { label: "Maestría", value: "Maestría" },
    { label: "Doctorado", value: "Doctorado" },
    { label: "Otros", value: "Otros" },
  ],
  VALORES_SATURACION_OX: [
    { valorMin: 95, valorMax: 99, estado: "Normal" },
    { valorMin: 91, valorMax: 94, estado: "Revisar condición" },
    { valorMin: 0, valorMax: 90, estado: "Requiere atención" },
    { valorMin: 100, valorMax: 200, estado: "Saturación eleveda" },
  ],
  IMAGES_URL: "Images",
  ESTADOS: [
    { label: "Aguascalientes", value: "Aguascalientes" },
    { label: "Baja California", value: "Baja California" },
    { label: "Baja California Sur", value: "Baja California Sur" },
    { label: "Campeche", value: "Campeche" },
    { label: "Chiapas", value: "Chiapas" },
    { label: "Chihuahua", value: "Chihuahua" },
    { label: "Ciudad de Mexico", value: "Ciudad de Mexico" },
    { label: "Coahuila de Zaragoza", value: "Coahuila de Zaragoza" },
    { label: "Colima", value: "Colima" },
    { label: "Durango", value: "Durango" },
    { label: "Guanajuato", value: "Guanajuato" },
    { label: "Guerrero", value: "Guerrero" },
    { label: "Hidalgo", value: "Hidalgo" },
    { label: "Jalisco", value: "Jalisco" },
    { label: "Mexico", value: "Mexico" },
    { label: "Michoacan de Ocampo", value: "Michoacan de Ocampo" },
    { label: "Morelos", value: "Morelos" },
    { label: "Nayarit", value: "Nayarit" },
    { label: "Nuevo Leon", value: "Nuevo Leon" },
    { label: "Oaxaca", value: "Oaxaca" },
    { label: "Puebla", value: "Puebla" },
    { label: "Queretaro", value: "Queretaro" },
    { label: "Quintana Roo", value: "Quintana Roo" },
    { label: "San Luis Potosi", value: "San Luis Potosi" },
    { label: "Sinaloa", value: "Sinaloa" },
    { label: "Sonora", value: "Sonora" },
    { label: "Tabasco", value: "Tabasco" },
    { label: "Tamaulipas", value: "Tamaulipas" },
    { label: "Tlaxcala", value: "Tlaxcala" },
    {
      label: "Veracruz de Ignacio de la Llave",
      value: "Veracruz de Ignacio de la Llave",
    },
    { label: "Yucatan", value: "Yucatan" },
    { label: "Zacatecas", value: "Zacatecas" },
    { label: "Extranjero", value: "Extranjero" },
  ],
};
